import { defineAsyncComponent } from 'vue';

const asyncGlobalComponents = {
	fbLoader: () => import('@/components/fbLoader.vue'),
	EGS_Modal: () => import('@/components/Modal/Modal.vue'),
	EGS_Dropdown: () => import('@/components/Dropdown/Dropdown.vue'),
	EGS_Autocomplete: () => import('@/components/ui/inputs/Autocomplete/Autocomplete.vue'),
	EGS_LocationAutocomplete: () => import('@/components/ui/inputs/Autocomplete/Autocomplete.vue'),
	EGS_Card: () => import('@/components/Card/EGS_Card.vue'),
	EGS_Alert: () => import('@/components/Alert/EGS_Alert.vue'),
	EGS_DateSelector: () => import('@/components/ui/inputs/Date Selector/DateSelector.vue'),
	EGS_AuthInput: () => import('@/components/AuthInput/AuthInput.vue'),
	EGS_OTP: () => import('@/components/OTP/EGS_OTP.vue'),
	EGS_ToggleSwitch: () => import('@/components/ToggleSwitch/ToggleSwitch.vue'),
	EGS_Chip: () => import('@/components/Chip/EGS_Chip.vue'),
	EGS_Dialog: () => import('@/components/Dialog/EGS_Dialog.vue'),
	EGS_Button: () => import('@/components/Button/EGS_Button.vue'),
	EGS_Input: () => import('@/components/ui/inputs/EGS_Input.vue'),
	EGS_MultiSelect: () => import('@/components/ui/inputs/MultiSelect/EGS_MultiSelect.vue'),
	EGS_ProgressBar: () => import('@/components/ProgressBar/ProgressBar.vue'),
	EGS_Currency: () => import('@/components/ui/inputs/Currency/CurrencyInput.vue'),
	EGS_Percentage: () => import('@/components/ui/inputs/Percentage/PercentageInput.vue'),
	EGS_Tooltip: () => import('@/components/Tooltip/Tooltip.vue'),
	EGS_OverlayBadge: () => import('@/components/OverlayBadge/OverlayBadge.vue'),
	EGS_Tab: () => import('@/components/Tab/Tab.vue'),
	EGS_ScrollTop: () => import('@/components/ScrollTop/EGS_ScrollTop.vue')
};

export function registerAsyncGlobalComponents(app) {
	for (const [name, loader] of Object.entries(asyncGlobalComponents)) {
		app.component(name, defineAsyncComponent(loader));
	}
}
